import { properties } from '../properties.js';
import React, { Component } from 'react';
import standard_abiA from '../../abis/Standard16A-abi.json';
import Swal from 'sweetalert2';
import 'react-datepicker/dist/react-datepicker.css'
import { PacmanLoader } from 'react-spinners'
import { withTranslation } from 'react-i18next';
import QRCode from "react-qr-code";
import i18n from '../I18N/I18n.js'; 
import Cookies from 'js-cookie';
import NavBar from '../navbar.js';
import Footer from '../footer.js';
import { logout, apiSecuredRequest, setBearer, isUserOrWallet, isRootWallet, imprimirQR} from '../functions.js';
import '../css/DPP16.css';




class DPPGenerator extends Component {

    async componentDidMount() {
        // 1. Carga de Web3
        const bearer = await this.checkIfWeb3UserOrLoginUser();
        await this.cargarCamposMarca(bearer);
       
        // 2. Carga de datos de la Blockchain

      //  await this.cargarCamposMarca()
    }


    cambiarIdioma = (idioma) => {
            const { i18n } = this.props;
            i18n.changeLanguage(idioma);
            Cookies.set('idiomaPreferido', idioma, { expires: 365 }); // Guarda la preferencia por un año // Cambia el idioma usando i18n
        };

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }

    async checkIfWeb3UserOrLoginUser() { 
        let params = (new URL(document.location)).searchParams;
        this.setState({saleDate: new Date()})
        const certificadoId = params.get("certificadoId");
        this.setState({ certificadoId: certificadoId })
        const certificadoName = params.get("certificadoName");
        this.setState({certificadoName})

        const empresa = JSON.parse(localStorage.getItem('empresa'));
        const empresaId = empresa.id;
        this.setState({empresaId})
        const empresaName = empresa.name;
        this.setState({empresaName})
      
        
        const email = Cookies.get("email");
        this.setState({ email: email });
        const direccion = Cookies.get("direccion");
        this.setState({direccion: direccion})
        const bearer = Cookies.get("id");
        this.setState({ bearer: bearer });
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        
        bearerVar = Cookies.get("id");
        let account = await isUserOrWallet(email, bearerVar);
        const isRootDir = await isRootWallet(account);
        this.setState({isRootDir: isRootDir});

        this.setState({account})
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
        return bearerToken;
    }

    async cargarCamposMarca(bearer) {

        var camposData

    
        camposData = JSON.stringify({
            "certificadoId": `${this.state.certificadoId}`,
            "tipoStandard": `DPP16`
        });
           
        const campos = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/campo/getCampos`, camposData, bearer);

        this.setState({ campos: campos.data })
        
    }


    _checkIfInfoCorrect = async (
      idLinea,
      campo0,
      campo1,
      campo2,
      campo3,
      campo4,
      campo5,
      campo6,
      campo7,
      campo8,
      campo9,
      campo10,
      campo11
    ) => {
      if (
        idLinea &&
        campo0 &&
        campo1 &&
        campo2 &&
        campo3 &&
        campo4 &&
        campo5 &&
        campo6 &&
        campo7 &&
        campo8 &&
        campo9 &&
        campo10 &&
        campo11
      )  {
            Swal.fire({
                icon: 'question',
                title: `${i18n.t('iscorrect')}`,
                imageUrl: `${this.state.fileInput}`,
                showDenyButton: true,
                html:
                    `
                      <style>
                    table {
                        width: 100%; /* Ensures the table uses the full width of the alert */
                        border-collapse: collapse; /* Neatly joins the borders */
                        background: #f8f8f8; /* Gives a subtle background color */
                        border-radius: 8px; /* Rounded corners for the table */
                        overflow: hidden; /* Ensures the border-radius clips the content */
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* Soft shadow around the table */
                    }
                    th, td {
                        padding: 12px 15px; /* Ample padding for table cells */
                        border-bottom: 1px solid #ddd; /* Light line below each row */
                    }
                    th {
                        background-color: #e94981; /* Vibrant pinkish-magenta background for the header */
                        color: white; /* White text for better readability */
                        font-size: 16px; /* Slightly larger text for headings */
                    }
                    td {
                        color: #333; /* Darker text color for better readability */
                        font-size: 14px; /* Standard text size */
                    }
                    tr:last-child td {
                        border-bottom: none; /* Removes border from the last row */
                    }
                    td:first-child {
                        text-align: right; /* Aligns the labels to the right */
                        font-weight: bold; /* Makes the labels bold */
                        background-color: #f0f0f0; /* Light grey background for labels */
                    }
                    td:last-child {
                        text-align: left; /* Ensures values are aligned to the left */
                        background-color: #f7f7f7; /* Lighter grey background for values, enhancing contrast */
                    }
                </style>

    <table>
        <thead>
            <tr>
                <th colspan="2">User Information</th>
            </tr>
        </thead>
       <tbody>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "IDLINEA")[0].nombreCampo}</td><td>${idLinea}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO0")[0].nombreCampo}</td><td>${campo0}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO1")[0].nombreCampo}</td><td>${campo1}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO2")[0].nombreCampo}</td><td>${campo2}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO3")[0].nombreCampo}</td><td>${campo3}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO4")[0].nombreCampo}</td><td>${campo4}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO5")[0].nombreCampo}</td><td>${campo5}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO6")[0].nombreCampo}</td><td>${campo6}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO7")[0].nombreCampo}</td><td>${campo7}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO8")[0].nombreCampo}</td><td>${campo8}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO9")[0].nombreCampo}</td><td>${campo9}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO10")[0].nombreCampo}</td><td>${campo10}</td></tr>
          <tr><td>${this.state.campos.filter(campo => campo.orden == "CAMPO11")[0].nombreCampo}</td><td>${campo11}</td></tr>
        </tbody>
    </table>`

                ,
                confirmButtonText:  `${i18n.t('generateCertificate')}`,
                denyButtonText: `${i18n.t('makeChanges')}`,
                confirmButtonColor: "#E94981",
                // denyButtonColor: "#F07577",
                width: '1000px',
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.setState({ loading: true })
                    this.setState({ idLinea})
                        // Después de que primeraFuncion termine, llamar a segundaFuncion
                        this._createDPP( idLinea,
                          campo0,
                          campo1,
                          campo2,
                          campo3,
                          campo4,
                          campo5,
                          campo6,
                          campo7,
                          campo8,
                          campo9,
                          campo10,
                          campo11
                        )
                    

                } else if (result.isDenied) {
                    Swal.fire({
                        title: `${i18n.t('changesNotSaved')}`,
                        confirmButtonText: `${i18n.t('continue')}`,
                        confirmButtonColor: '#E94981',
                        icon: 'info',
                        iconColor: '#66C08B',
                        width: '560px',
                    })
                }
            })
        } else {
            Swal.fire({
                title: `${i18n.t('missingFields')}`,
                text: '',
                icon: 'error',
                confirmButton: 'Back',
                confirmButtonColor: "#E94981",
            })
        }
    }


    _createCertificateDataforCusomedUser = async (idProductoA, idProductoB, erc721A, erc721B) => {
        if (idProductoA == idProductoB && this.state.account != 0) {

            const apiUserNfts = await apiSecuredRequest(
                "get", 
                `${properties.apiUrl}/certificat/api/standardData/standardInfo/getByUseridAndCertificadoId/${this.state.userId}/${this.state.certificadoId}/16/${idProductoA}`, 
                "", 
                this.state.bearer
            );
    



            if (apiUserNfts.data.length == 0) {

                let certificateData = JSON.stringify({
                    "idProducto": `${idProductoA}`,
                    "erc721IdA": `${erc721A}`,
                    "erc721IdB": `${erc721B}`,
                    "erc721IdC": null,
                    "userId": `${this.state.userId}`,
                    "certificadoId": `${this.state.certificadoId}`,
                    "validated": false,
                    "standardType": "DP"
                });
                const config = await apiSecuredRequest(
                    "post", 
                    `${properties.apiUrl}/certificat/api/standardData/request`, 
                    certificateData, 
                    this.state.bearer
                );
    
                console.log(config);
                return config.data;

            } 

        }

    }


    _createDPP = async (idLinea,
      campo0,
      campo1,
      campo2,
      campo3,
      campo4,
      campo5,
      campo6,
      campo7,
      campo8,
      campo9,
      campo10,
      campo11
    ) => {
        let ercIdA;
        let ercIdB;
        let idProductoAVar;
        let idProductoBVar;
        let modeloVar;
        try {
          
          
            if(this.state.account != 0) {
                let gasPriceVar = await web3.eth.getGasPrice();
    
                // Aumentar el gasPrice dinámicamente (por ejemplo, multiplicar por 1.5 para tener mayor prioridad)
                let gasPriceBigInt = BigInt(gasPriceVar); // Asegúrate de que sea BigInt

                // Aumentar el gasPrice multiplicando por 1.5 (multiplicar por 3 y dividir por 2)
                let gasPriceIncreased = (gasPriceBigInt * BigInt(3)) / BigInt(2);
             

                const abi = standard_abiA
            
                console.log('abi', abi)
                const certificado = JSON.parse(localStorage.getItem('certificado'));
		            const address = certificado.direccion;
                const address2 = certificado.direccion2;
		            this.setState({direccion: address})
               

                if(abi && address && address2) {
             
                    const contractA = new web3.eth.Contract(abi, address)


                    try{
                            const productDataCreation = await contractA.methods.createDPP(idLinea,
                              campo0,
                              campo1,
                              campo2,
                              campo3,
                              campo4,
                              campo5
                            ).send({
                                from: this.state.account, gasPrice: gasPriceIncreased
                            });

                            const productDataCreation2 = await contractA.methods.createDPP(idLinea,
                              campo6,
                              campo7,
                              campo8,
                              campo9,
                              campo10,
                              campo11
                            ).send({
                                from: this.state.account, gasPrice: gasPriceIncreased
                            });

                            ercIdA = productDataCreation?.events?.NewStandardDataA?.returnValues?._id !== undefined 
                            ? productDataCreation.events.NewStandardDataA.returnValues._id 
                            : 'Valor predeterminado';
                            ercIdB = productDataCreation2?.events?.NewStandardDataA?.returnValues?._id !== undefined 
                            ? productDataCreation.events.NewStandardDataA.returnValues._id : 'Valor predeterminado';
                            modeloVar =  productDataCreation.events.NewStandardDataA.returnValues._modelo;
                            idProductoAVar = productDataCreation.events.NewStandardDataA.returnValues._idProducto;

                            const qrRequestData = JSON.stringify({
                                "certificadoId": `${this.state.certificadoId}`,
                                 
                                "usuarioId": `${this.state.userId}`,
                                "standardType": "dpp16",
                                "standard8A": {
                                  "idProducto": `${idProducto}`,
                                  "modelo": `${modelo}`
                                }
                              });


                            const response = await apiSecuredRequest("post", `${properties.apiUrl}/certificat/api/web3jService/generateQR-and-send`, qrRequestData, this.state.bearer);
                            const certificateDataResult = await this._createCertificateDataforCusomedUser(idProductoAVar, idProductoBVar, ercIdA, ercIdB);

                        }catch (err) {
                            this.setState({ errorMessage: err })
                        }
                            
                }else{
                    Swal.fire({
                        title: 'ERROR',
                        text: `${i18n.t('somethingWentWrong')}`,
                        imageUrl: `${this.state.imageUrl}`,
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Go to admin tool'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = "/"
                        }
                    })
                }
            }else{

              let data = JSON.stringify({
                "idLinea": `${idLinea}`, // Identificador único de la línea
                "campo0": `${campo0}`,   // Campo genérico 0
                "campo1": `${campo1}`,   // Campo genérico 1
                "campo2": `${campo2}`,   // Campo genérico 2
                "campo3": `${campo3}`,   // Campo genérico 3
                "campo4": `${campo4}`,   // Campo genérico 4
                "campo5": `${campo5}`,
                "campo6": `${campo6}`,   // Campo genérico 6
                "campo7": `${campo7}`,   // Campo genérico 7
                "campo8": `${campo8}`,   // Campo genérico 8
                "campo9": `${campo9}`,   // Campo genérico 9
                "campo10": `${campo10}`, // Campo genérico 10
                "campo11": `${campo11}`, // Campo genérico 11
                "certificadoId": `${this.state.certificadoId}`,
                "direccionPropietario": `${properties.proofUHostWallet}`,
                "email": `${this.state.email}`
              });
              

                const response = apiSecuredRequest("post", `${properties.apiUrl}/certificat/api/standardData/DPP16/create`, data, this.state.bearer);
               
            }
            await this._generateQRCertificate();
            this.setState({ loading: false })
           
            Swal.fire({
              title: `${i18n.t('availableSoon')}`,
              text: '',
              icon: 'success',
              confirmButton: 'Back',
              confirmButtonColor: "#E94981",
          })
        } catch (err) {
            this.setState({ errorMessage: err })
        } finally {
            this.setState({ loading: false })
        }
    }

    _generateQRCertificate = async()  => {
  
        // QR for quick validation generation
        const QRValidationUrl = `${properties.clientApp}/${this.state.empresaMapping}/DPP16/QRDPP?idLinea=${this.state.idLinea}&certificadoId=${this.state.certificadoId}`;
        this.setState({ QRCode: QRValidationUrl })
      }

      _createCertificateDataforCusomedUser = async (idProductoA, idProductoB, erc721A, erc721B) => {
        if (idProductoA == idProductoB && this.state.account != 0) {

            const apiUserNfts = await apiSecuredRequest(
                "get", 
                `${properties.apiUrl}/certificat/api/standardData/standardInfo/getByUseridAndCertificadoId/${this.state.userId}/${this.state.certificadoId}/DPP16/${idProductoA}`, 
                "", 
                this.state.bearer
            );
    



            if (apiUserNfts.data.length == 0) {

                let certificateData = JSON.stringify({
                    "idProducto": `${idProductoA}`,
                    "erc721IdA": `${erc721A}`,
                    "erc721IdB": `${erc721B}`,
                    "erc721IdC": null,
                    "userId": `${this.state.userId}`,
                    "certificadoId": `${this.state.certificadoId}`,
                    "validated": false,
                    "standardType": "DPP16"
                });
                const config = await apiSecuredRequest(
                    "post", 
                    `${properties.apiUrl}/certificat/api/standardData/request`, 
                    certificateData, 
                    this.state.bearer
                );
    
                console.log(config);
                return config.data;

            } 

        }

    }

    constructor(props) {
      super(props)
      this.state = {
          account: "0x0",
          contractA: null,
          isRootDir: null,
          certificadoName: null,
          empresaName: null,
          saleDate: null,
          idLinea: null,
          ownerAddress: null,
          userId: null,
          email: null,
          userEmail: null,
          isChecked: null,
          empresaMapping: null,
          certificadoId: null,
          empresaId: null,
          loading: false,
          campos: null,
          QRcode: null
      }
  }

    render() {
        if (this.state.loading == true) {
            return (

                <>
                 <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
                   <div>
                    <h1>Certificate Generator</h1>
                    <button className="cewy-button-link cewy-button-left" onClick={() => {
   
   window.location.href = `/${this.state.empresaMapping}/listaCertificados?empresaId=${this.state.empresaId}&empresaName=${this.state.empresaName}`
 
 }}>
            {i18n.t('backToEnterprise')}
   </button>  
                </div>

                <div>
                    <PacmanLoader color="#E94981" cssOverride={{}} />
                </div>
                <Footer />
                </>
            );
        }else if (this.state.campos != null) {

            return (
                <>

<NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />
{this.state.QRCode != null && (
  <div className="custom-qrcode-container">
    <QRCode value={this.state.QRCode} />

    <button
      className="custom-qrcode-button"
      onClick={() => {
        imprimirQR(this.state.QRCode);
      }}
    >
      {i18n.t('imprimirQR')}
    </button>
  </div>
)}

<form
  onSubmit={(event) => {
    event.preventDefault();
    const idLinea = this.idLinea.value;
    const campo0 = this.campo0.value;
    const campo1 = this.campo1.value;
    const campo2 = this.campo2.value;
    const campo3 = this.campo3.value;
    const campo4 = this.campo4.value;
    const campo5 = this.campo5.value;
    const campo6 = this.campo6.value;
    const campo7 = this.campo7.value;
    const campo8 = this.campo8.value;
    const campo9 = this.campo9.value;
    const campo10 = this.campo10.value;
    const campo11 = this.campo11.value;
    this._checkIfInfoCorrect(
      idLinea,
      campo0,
      campo1,
      campo2,
      campo3,
      campo4,
      campo5,
      campo6,
      campo7,
      campo8,
      campo9,
      campo10,
      campo11
    );
  }}
  className="custom-form"
>
  <div className="custom-main-content-2col">
    {/* ID Línea solitario */}
    <div className="custom-id-linea">
      <label className="custom-id-label">
        {this.state.campos.filter((campo) => campo.orden == 'IDLINEA')[0].nombreCampo}
      </label>
      {this.state.template == null ? (
        <input
          type="text"
          ref={(idLinea) => (this.idLinea = idLinea)}
          className="custom-id-input"
        />
      ) : (
        <input
          type="text"
          value={this.state.template.idLinea}
          ref={(idLinea) => (this.idLinea = idLinea)}
          className="custom-id-input"
        />
      )}
    </div>

    {/* Contenedor de dos columnas */}
    <div className="custom-columns-container">
      {/* Primera columna */}
      <div className="custom-column-container">
        {Array.from({ length: 6 }).map((_, i) => (
          <>
            <label className="custom-label-2col">
              {this.state.campos.filter((campo) => campo.orden === `CAMPO${i}`)[0].nombreCampo}
            </label>
            {this.state.template == null ? (
              <input
                type="text"
                ref={(campo) => (this[`campo${i}`] = campo)}
                className="custom-input-2col"
              />
            ) : (
              <input
                type="text"
                value={this.state.template[`campo${i}`]}
                ref={(campo) => (this[`campo${i}`] = campo)}
                className="custom-input-2col"
              />
            )}
          </>
        ))}
      </div>

      {/* Segunda columna */}
      <div className="custom-column-container">
        {Array.from({ length: 6 }, (_, i) => i + 6).map((i) => (
          <>
            <label className="custom-label-2col">
              {this.state.campos.filter((campo) => campo.orden === `CAMPO${i}`)[0].nombreCampo}
            </label>
            {this.state.template == null ? (
              <input
                type="text"
                ref={(campo) => (this[`campo${i}`] = campo)}
                className="custom-input-2col"
              />
            ) : (
              <input
                type="text"
                value={this.state.template[`campo${i}`]}
                ref={(campo) => (this[`campo${i}`] = campo)}
                className="custom-input-2col"
              />
            )}
          </>
        ))}
      </div>
    </div>

    {/* Botones */}
    <div className="custom-button-container-2col">
      <button id="generate-button" className="custom-button-2col" type="submit">
        {i18n.t('generateDPP')}
      </button>

      <button
        className="custom-button-2col"
        onClick={() => {
          window.location.href = `/listaEmpresas`;
        }}
      >
        {i18n.t('backToEnterprise')}
      </button>
    </div>
  </div>
</form>

<Footer />

</>

            );
        
        }


    }
    





}export default withTranslation()(DPPGenerator);